import { render, staticRenderFns } from "./BuscaInput.vue?vue&type=template&id=12c4f428"
import script from "./BuscaInput.vue?vue&type=script&lang=js"
export * from "./BuscaInput.vue?vue&type=script&lang=js"
import style0 from "./BuscaInput.vue?vue&type=style&index=0&id=12c4f428&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports